<template>
    <div>
        <p class="headline">
            <v-icon style="margin-top:-5px;">radio</v-icon> Manage
            <small>radios and monitor status</small>
        </p>
        <v-breadcrumbs :items="items">
            <template v-slot:item="props">
                <v-icon v-if="props.item.icon" style="color:#fff;">{{props.item.icon}}</v-icon>
                <v-breadcrumbs-item
                @click.prevent="props.item.href"
                :class="[props.item.disabled && 'disabled']"
                >{{ props.item.text.toUpperCase() }}</v-breadcrumbs-item>
            </template>
        </v-breadcrumbs>
        <v-card tile class="mt-4">
            <v-card-title>Radios
                <v-spacer></v-spacer>
                <v-text-field
                    dense
                    v-model="search"
                    style="max-width: 350px;"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                    @click:append="searchNow"
                ></v-text-field>
                <v-btn 
                    color="primary ma-3" 
                    tile 
                    @click.stop="dialog = !dialog">
                    Add Radio
                </v-btn>
            </v-card-title>
            
            <v-data-table
                dense
                :options.sync="options"
                :server-items-length="totalItems"
                :loading="loading"
                :search="search"
                :headers="headers"
                :items="radios"
                :items-per-page="20"
                item-key="id"
                class="elevation-1"
                :footer-props="{
                    itemsPerPageOptions:[10,20,30,50,100,-1]
                }"
                >
                <template v-slot:[`item.name`]="{item}">
                    <!-- <div class="truncate-text">{{item.name}}</div> -->
                    <v-tooltip top text>
                    <template v-slot:activator="{ on }">
                        <span
                        v-on="on"
                        >{{item.name}}</span>
                    </template>
                    <span>
                        <!-- <b>Firmware:</b> {{getShortFirmware(item)}} <br> -->
                        <b>Available Storage: </b>{{getStorage(item)}} <br>
                        <b>Local IP:</b> {{item.local_ip}} <br>
                        <b>Public IP:</b> {{item.public_ip}} <br>
                    </span>
                    </v-tooltip>
                </template>
                <template v-slot:[`item.model`]="{item}">
                    <!-- <div class="truncate-text">{{item.name}}</div> -->
                    <v-tooltip top text>
                    <template v-slot:activator="{ on }">
                        <span
                        v-on="on"
                        >{{item.model}}</span>
                    </template>
                    <span>
                        <!-- <b>Firmware:</b> {{getShortFirmware(item)}} <br> -->
                        <b>Available Storage: </b>{{getStorage(item)}} <br>
                        <b>Local IP:</b> {{item.local_ip}} <br>
                        <b>Public IP:</b> {{item.public_ip}} <br>
                    </span>
                    </v-tooltip>
                </template>
                <template v-slot:[`item.serial`]="{item}">
                    <v-tooltip top text>
                    <template v-slot:activator="{ on }">
                        <span
                        v-on="on"
                        >{{item.serial}}</span>
                    </template>
                    <span>
                        <!-- <b>Firmware:</b> {{getShortFirmware(item)}} <br> -->
                        <b>Available Storage: </b>{{getStorage(item)}} <br>
                        <b>Local IP:</b> {{item.local_ip}} <br>
                        <b>Public IP:</b> {{item.public_ip}} <br>
                    </span>
                    </v-tooltip>
                </template>
                <template v-slot:[`item.firmware`]="{item}">
                    <span>{{getShortFirmware(item)}}</span>
                </template>
                <template v-slot:[`item.channel`]="{item}">
                    <span> ({{ (item.channel_name == 0 || item.channel_name == '0' || item.channel_name == null)?'0':item.channel_number }})  {{ (item.channel_name == 0 || item.channel_name == '0' || item.channel_name == null)?'Not playing':item.channel_name }}</span>
                </template>
                <template v-slot:[`item.schedule_name`]="{ item }">
                    <v-btn small depressed text style="text-transform:none; font-weight: normal; justify-content:normal;" class="ma-0 pa-0" color="primary" :to="'/dashboard/schedules/'+item.schedule_id">{{ item.schedule_name}}</v-btn>
                </template>
                <template v-slot:[`item.playlist_name`]="{item}">
                    <v-btn small depressed text style="text-transform:none; font-weight: normal; justify-content:normal;" class="ma-0 pa-0" color="primary" to="/dashboard/playlist">{{ getPlaylistName(item.schedule_id) }}</v-btn>
                </template>
                <!-- <template v-slot:item.firmware="{item}">
                    <span> {{getShortFirmware(item)}}</span>
                </template> -->
                <template v-slot:[`item.company`]="">
                    {{getCompany()}}
                </template>
                
                <template v-slot:[`item.message_count`]="{item}">
                    {{item.message_count? item.message_count : 0}}
                </template>
                <template v-slot:[`item.reported_at`]="{item}">
                    <span>{{ getUserTime(item.reported_at) }}</span>
                </template>

                <template v-slot:[`item.action`]="{ item }">
                  <v-icon
                    small
                    class="mr-2"
                    @click="editItem(item)"
                  >
                    edit
                  </v-icon>
                  <v-icon
                    small
                    @click="deleteItem(item)"
                  >
                    delete
                  </v-icon>
                </template>
            </v-data-table>
        </v-card>
        <v-dialog v-model="dialog" persistent max-width="600">
            <v-card tile>
                <v-card-title class="pl-8">{{dialogTitle}}</v-card-title>
                <v-card-text>
                    <v-form ref="radioForm">
                        <v-col>
                            <v-text-field 
                                dense
                                label="Name" 
                                v-model="editedItem.name" 
                                :rules="nameRules">
                            </v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field
                                dense
                                label="Serial" 
                                v-model="editedItem.serial" 
                                :rules="[
                                ()=> !!editedItem.serial || 'This serial field is required.',
                                (v)=> (v && v.length >= 6) || 'This serial field must be 6',
                                (v)=> (v && /^[a-z0-9A-Z]+$/.test(v)) || 'Enter a valid serial'
                                ]"
                                maxlength="6">
                                <div v-if="serialAlreadyExists" class="v-messages theme--light error--text mt-2" role="alert">
                                    <div class="v-messages__wrapper">
                                    <div class="v-messages__message">{{serialAlreadyExistsMessage}}</div>
                                    </div>
                                </div>
                            </v-text-field>
                        </v-col>
                        <v-col>
                            <v-autocomplete
                                dense
                                class="mt-2"
                                label="Model"
                                :items="models"
                                item-text="model"
                                autocomplete="off"
                                v-model="editedItem.model"
                                :rules="[
                                (v) => !!v || 'This model field is required.'
                                ]"
                            ></v-autocomplete>
                        </v-col>
                        <v-col>
                            <v-autocomplete
                                dense
                                class="mt-2"
                                label="Select Schedule"
                                :items="schedules"
                                autocomplete="off"
                                item-text="name"
                                return-object
                                :rules="[
                                (v) => !!v || 'This schedule field is required.'
                                ]"
                                v-model="selectedSchedule"
                            ></v-autocomplete>
                        </v-col>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="warning" @click="close" tile>Close</v-btn>
                    <v-btn color="primary" tile class="mr-4" @click.prevent="save">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog 
            max-width="400"
            v-model="deleteDialog">
            <v-card tile>
                <v-card-title>Are you sure?</v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pa-6">
                    <p class="title">You want to delete this radio?</p>
                    <div v-if="shouldDeleteItem" class="user-info">
                        <p class="mb-1">Radio name: {{shouldDeleteItem.name}}</p>
                    </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click.prevent="deleteDialogClose" tile >No</v-btn>
                    <v-btn color="red accent-4" @click.prevent="confirmDelete" tile class="white--text">Yes</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import axios from './../../../axios'
import moment from 'moment-timezone'
export default {
    data(){
        return {
            retriver:null,
            search:null,
            serialAlreadyExists:false,
            serialAlreadyExistsMessage:'The serial has already been taken.',
            singleExpand:true,
            expanded: [],
            removeRadioDialog:false,
            unlink:'',
            dialog:false,
            dialogTitle:'Add Radio',
            items: [
                {
                text: "Radios",
                disabled: true,
                href: '#',
                icon: 'radio'
                }
            ],
            headers:[
                { text: 'Name', value:'name'},
                { text: 'Model', value:'model'},
                { text: 'Serial', value: 'serial'},
                { text: 'Firmware', value: 'firmware'},
                { text: 'SXM Username', value: 'radio_status_username'},
                { text: 'Company', value: 'company', sortable: false},
                { text: 'Channel', value:'channel', width: '8%', sortable: false},
                { text: 'Schedule', value: 'schedule_name'},
                {text: 'Message Playlist', value: 'playlist_name'},
                // {text: 'Available Storage', value: 'available_storage'},
                {text: '# messages', value: 'message_count'},
                { text: 'Last Reported', value: 'reported_at'},
                { text: 'Actions', value: 'action', sortable: false}
            ],
            scheduleHeaders:[
                {text: 'ID', value: 'id'},
                {text: 'Name', value: 'name'},
                {text: 'Action', value: 'action', width: '10%'}
            ],
            radios:[],
            models:[],
            schedules:[],
            selectedSchedule:null,
            selectedRadio:null,
            allPlaylist:[],
            editedItem:{
                id:0,
                name:'',
                model:'',
                serial:'',
                created_at:'',
                updated_at:''
            },
            defaultItem:{
                id:0,
                name:'',
                model:'',
                serial:'',
                created_at:'',
                updated_at:''
            },
            loading: false,
            totalItems:0,
            options:{
                token:this.$store.getters.getToken,
                page: 1,
                itemsPerPage: 20,
                sortBy: [],
                sortDesc: [],
                multiSort:true,
                trashed: 'no',
                keyword: ''
            },
            editedIndex:-1,
            deleteDialog:false,
            isConfirmDelete:false,
            shouldDeleteItem:null,
            nameRules: [
                    v => !!v || 'Radio name is required',
                ],
            serialRules: [
                    v => !!v || 'Radio serial number is required',
                ],
        }
    },
    methods:{
        getStorage(item){
            if(item.available_storage){
                return (parseInt(item.available_storage) / 1000).toFixed(2) + ' MB'
            }else{
                return 'N/A'
            }
            
        },
        searchNow(){
            this.options.keyword = this.search
        },
        getPlaylists(){
            axios.get('radio-playlist', {
                params:{
                    token: this.$store.getters.getToken,
                    user_id: this.$store.getters.getUser
                }
            })
            .then(response=>{
                this.allPlaylist = response.data.radiosPlaylists
            })
            .catch(error=>{
                console.log(error.response)
            })
        },
        getPlaylistName(id){
            let playlist = this.allPlaylist.filter(p=>{
                return p.schedule_id == id
            })
            if(playlist.length > 0){
                return playlist[0].name
            }
            
        },
        getCompany(){
            return localStorage.getItem('company')
        },
        getShortFirmware(item){
            if(item.firmware == null){
                return 'Not reported'
            }else{

                let firmwareArray = item.firmware.split('.')
                let firmware = ''
                if(firmwareArray.length > 3){
                    firmware = firmwareArray[1] + '.' + firmwareArray[2]
                }else{
                    firmware = item.firmware
                }
                return firmware
            }
        },
        getUserTime(time){
            if(time == null){
                return 'Not reported'
            }else{
                return moment.tz(time, "YYYY-MM-DD HH:mm", "UTC")
                .tz(this.$store.getters.getTimezone).format("hh:mm A MM-DD-YYYY")
            }
        },
        editItem(item){
            this.dialogTitle = 'Edit Radio'
            this.serialAlreadyExists = false
            this.editedIndex = this.radios.indexOf(item)
            this.editedItem = Object.assign({},item)
            
            let schedule = this.schedules.filter((r)=>{
                return r.id==this.editedItem.schedule_id
            })
            this.selectedSchedule = schedule[0]
            this.dialog = true
        },
        deleteItem(item){
            this.shouldDeleteItem = null
            this.shouldDeleteItem = item
            this.deleteDialog = true
        },
        confirmDelete(){
            const index = this.radios.indexOf(this.shouldDeleteItem)
            axios.delete('radio/'+this.shouldDeleteItem.id+'?token='+this.$store.getters.getToken)
                .then(response=>{
                    this.$store.dispatch('setAlert', response.data.message)
                    this.radios.splice(index, 1)
                    this.deleteDialog = false
                })
                .catch(error => {
                    this.$store.dispatch('setErrorAlert', error.response.data.message)
                    this.deleteDialog = false
                })
        },
        deleteDialogClose(){
            this.shouldDeleteItem=null
            this.deleteDialog = false
        },
        save(){

            if(!this.$refs.radioForm.validate()) return
            let formData = {
                name: this.editedItem.name,
                serial: this.editedItem.serial,
                model: this.editedItem.model,
                schedule_id: (this.selectedSchedule)?this.selectedSchedule.id:0
            }
            if (this.editedIndex > -1) {
                axios.put('radio/'+this.editedItem.id+'?token='+this.$store.getters.getToken, formData)
                    .then(response=>{
                        this.$store.dispatch('setAlert', response.data.message)
                        this.getRadios()
                        this.close()
                    })
                    .catch(error=>{
                        this.$store.dispatch('setErrorAlert', error.response.data.message)
                    })        
            }else{
                axios.post('radio?token='+this.$store.getters.getToken,formData)
                    .then(response=>{
                        this.$store.dispatch('setAlert', response.data.message)
                        this.close()
                        this.getRadios()  
                    })
                    .catch(error=>{
                        if(error.response.data.errors['serial']){
                            this.$store.dispatch('setErrorAlert', error.response.data.errors['serial'][0])
                        }else{
                            this.$store.dispatch('setErrorAlert', 'There is an error to create radio')
                        } 
                    })
 
            }
        },
        close(){
            this.dialog = false
            setTimeout(()=>{
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
                this.dialogTitle = 'Add Radio'
                this.$refs.radioForm.resetValidation()
                this.$refs.radioForm.reset()
            },100)
        },
        getRadios(){
            axios.get('radio', {
                params: this.options
            })
            .then(response=>{ 
                // console.log(response.data)
                this.radios = response.data.radios.data 
                this.totalItems= response.data.radios.total

                // this.radios.sort(function(a, b){
                //     var keyA = new Date(a.reported_at),
                //         keyB = new Date(b.reported_at)
                //     if(keyA > keyB) return -1
                //     if(keyA < keyB) return 1
                //     return 0
                // })
            })
            .catch(error=>{
                this.$store.dispatch('setErrorAlert', error.response.data.message)
            })
        },
        getSchedules(){
            axios.get('schedule?token='+this.$store.getters.getToken)
                .then(response=>{
                    this.schedules = response.data.schedules 
                    let no_schedule = {
                        id: 0,
                        description: '',
                        name: 'No Schedule',
                        status: null,
                        user_id: null,
                        version: null,
                        day_active: null,
                        radio: null
                    }
                
                    this.schedules.unshift(no_schedule)
                })
                .catch(error=>{
                    this.$store.dispatch('setErrorAlert', error.response.data.message)
                })
        }
    },
    watch:{
        serialNumber:(serial)=>{
            console.log(serial)
        },
        options: {
            handler () {
                this.getRadios()
            },
            deep: true,
        }
    },
    created(){
        this.getPlaylists()
        this.getRadios()

        if(this.retriver){
            clearInterval(this.retriver)
        }
        
        this.retriver = setInterval(()=>{
            this.getRadios()
        }, 60000)

        this.getSchedules()

        axios.get('models?token='+this.$store.getters.getToken)
            .then(response=>{
                this.models = response.data.models
            })
            .catch(error=>{
                this.$store.dispatch('setErrorAlert', error.response.data.message)
            })

        localStorage.setItem('currentUrl', '/dashboard/radios');
    },
    beforeDestroy(){
        if(this.retriver){
            clearInterval(this.retriver)
        }
    }
    
}
</script>
<style scoped>
.v-breadcrumbs {
  background-color: #0f4e74;
  padding: 6px 8px;
  color: #fff;
}
.v-breadcrumbs__item {
  color: #fff;
}

.v-card__text, .v-card__title {
    padding: 0px 16px;
}

.truncate-text{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>